import { AppLayout } from "@/layouts/AppLayout";
import { MainRouter } from "@/routes/MainRouter";
import { CanonicalManager } from "@/components/CanonicalManager";

export default function App() {
  return (
    <AppLayout>
      <CanonicalManager />
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebSite",
          url: "https://laschispas.com/",
          potentialAction: {
            "@type": "SearchAction",
            target: "https://laschispas.com/islands?q={search_term_string}",
            "query-input": "required name=search_term_string",
          },
        })}
      </script>
      <MainRouter />
    </AppLayout>
  );
}
